/*
 * Urban Customz Premade — theme loader (≈2 KB).
 * Loads the configurator bundle from the configured origin when the shopper is about to use it (first
 * pointer/touch, the section scrolling into view, or after a short idle), mounts it into
 * [data-uc-premade] and only then hides the native cart form. Until that moment, and if the bundle
 * cannot load, the native form keeps the page buyable. Runs only on pages that render
 * sections/uc-premade.liquid. Nothing global is touched.
 */
(function () {
  "use strict";
  var configEl = document.querySelector("[data-uc-premade-config]");
  var mountEl = document.querySelector("[data-uc-premade]");
  var section = document.querySelector("[data-uc-premade-section]");
  var form = document.querySelector("[data-uc-premade-form]");
  if (!configEl || !mountEl || !section) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  // Development override: only localhost/127.0.0.1 origins are accepted, so this can never load
  // third-party code. Enabled per section setting; the override sticks for the tab via sessionStorage.
  var params = new URLSearchParams(location.search);
  var override = params.get("uc_origin");
  if (config.allowLocalOriginOverride) {
    try {
      if (override && /^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(override)) sessionStorage.setItem("uc_origin", override);
      var stored = sessionStorage.getItem("uc_origin");
      if (stored && /^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(stored)) config.apiOrigin = stored;
    } catch (e) {}
  }
  var origin = String(config.apiOrigin || "").replace(/\/$/, "");
  var bundleUrl = origin + "/premade/uc-premade.js";
  var loaded = null;
  var mounted = false;

  function loadBundle() {
    if (loaded) return loaded;
    if (window.UCPremade) return (loaded = Promise.resolve(window.UCPremade));
    // An ES module: dynamic import, not a classic script tag.
    loaded = new Function("u", "return import(u)")(bundleUrl)
      .then(function (m) {
        var api = (m && m.default) || window.UCPremade;
        if (!api) throw new Error("bundle did not register");
        return api;
      })
      .catch(function (e) {
        loaded = null;
        throw e;
      });
    return loaded;
  }

  function mount() {
    if (mounted) return;
    mounted = true;
    loadBundle()
      .then(function (app) {
        return app.mount(mountEl, config);
      })
      .then(function () {
        // The configurator is on the page: the native form steps aside.
        mountEl.hidden = false;
        if (form) form.hidden = true;
        track("uc_premade_mounted");
      })
      .catch(function () {
        // The page stays buyable through the native form.
        mounted = false;
        track("uc_premade_mount_failed");
      });
  }

  function track(name, props) {
    var payload = Object.assign({ event: name, product_handle: config.handle, design: config.designSlug }, props || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, props || {});
    } catch (e) {}
  }

  // Intent: the first pointer or touch anywhere on the section mounts at once.
  ["pointerenter", "touchstart", "focusin"].forEach(function (ev) {
    section.addEventListener(ev, mount, { once: true, passive: true });
  });
  // Visibility: the section scrolling into view mounts as well.
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        io.disconnect();
        mount();
      }
    });
    io.observe(section);
  }
  // Idle: a shopper who does nothing for a moment still gets the live preview.
  var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1500); };
  idle(function () { mount(); }, { timeout: 2500 });
})();
